import KeenSlider from "keen-slider";

export const GlobalCarrosseis = {
  init: function () {
    this.cacheSelectors();
    this.bindEvents();

  },

  cacheSelectors: function () {
    this.containerInstagram =
      document.querySelector("#section_instagram") || null;
    this.containerRecipe = document.querySelector("#section-recipe") || null;
    
    this.containerProductsInternal = document.querySelector("#slide-camponesa") || null;

    this.containerPreparetionInternal = document.querySelector("#slider-prepation") || null;

    this.containerBannerRecipe =
      document.querySelector("#recipe-banner") || null;

    this.containerBoss = document.querySelector("#boss-recipe") || null;

    this.containerProduct =
      document.querySelector("#carrossel-mobile_products") || null;

    this.containerProduct =
      document.querySelector("#carrossel-mobile_products") || null;

    this.containerCreativity =
      document.querySelector("#carrossel-creativity") || null;
  },

  bindEvents: function () {
    if (this.containerCreativity) {
      this.creativityCarrossel();
    }

    if (this.containerInstagram) {
      this.instagramCarrossel();
    }

    if (this.containerRecipe) {
      this.recipeCarrossel();
    }

    if (this.containerBannerRecipe) {
      this.recipesBannerCarrossel();
    }

    if (this.containerBoss) {
      this.recipesBossCarrossel();
    }

    if (this.containerProduct) {
      this.productsCarrossel();
    }

    if (this.containerProductsInternal) {
      this.productsInternal();
    }

    if (this.containerPreparetionInternal) {
      this.preparetionInternal();
    }


  },
  creativityCarrossel: function () {
    const sliderCreativity = new KeenSlider(
      "#carrossel-creativity",
      {
        loop: false,
        mode: "snap",
        rtl: false,
        slides: {
          perView: 1,
          spacing: 16,
        },
      },
      [(slider) => initializetionSlide(slider)]
    );

    function initializetionSlide(slider) {
      let arrows__prev = document.querySelector(
        ".creativity__mobile .arrow__prev"
      );
      let arrows__next = document.querySelector(
        ".creativity__mobile .arrow__next"
      );

      arrows__next.addEventListener("click", () => {
        slider.next();
      });

      arrows__prev.addEventListener("click", () => {
        slider.prev();
      });

      function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0
          ? arrows__prev.classList.add("arrow--disabled")
          : arrows__prev.classList.remove("arrow--disabled");

        slide === slider.track.details.slides.length - 1
          ? arrows__next.classList.add("arrow--disabled")
          : arrows__next.classList.remove("arrow--disabled");
      }

      // Adiciona eventos no slider para atualizar os botões
      slider.on("created", updateClasses);
      slider.on("slideChanged", updateClasses);
    }
  },
  instagramCarrossel: function () {
    new KeenSlider(
      "#instagram--slider",
      {
        loop: false,
        mode: "snap",
        rtl: false,
        slides: {
          perView: "auto",
          spacing: 16,
        },
      },
      [(slider) => initializetionSlide(slider)]
    );

    function initializetionSlide(slider) {
      let arrows__prev = document.querySelector(
        "#section_instagram .arrow__prev"
      );
      let arrows__next = document.querySelector(
        "#section_instagram .arrow__next"
      );

      arrows__next.addEventListener("click", () => {
        slider.next();
      });

      arrows__prev.addEventListener("click", () => {
        slider.prev();
      });

      function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0
          ? arrows__prev.classList.add("arrow--disabled")
          : arrows__prev.classList.remove("arrow--disabled");

        slide === slider.track.details.slides.length - 1
          ? arrows__next.classList.add("arrow--disabled")
          : arrows__next.classList.remove("arrow--disabled");
      }

      // Adiciona eventos no slider para atualizar os botões
      slider.on("created", updateClasses);
      slider.on("slideChanged", updateClasses);
    }
  },
  recipesBannerCarrossel: function () {
    new KeenSlider("#recipe-banner", {
      loop: true,
      mode: "snap",
      rtl: false,
      slides: {
        perView: "auto",
        spacing: 8,
      },
    });
    const changeSlide = () => {
      sliderRecipe.next();
    };

    const slideInterval = setInterval(changeSlide, 2500);
    sliderRecipe.on("dragStart", () => {
      clearInterval(slideInterval);
    });
  },
  recipeCarrossel: function () {
    new KeenSlider(
      "#recipe--slider",
      {
        loop: false,
        mode: "snap",
        rtl: false,
        slides: {
          perView: "auto",
          spacing: 50,
        },
        breakpoints: {
          "(max-width: 767px)": {
            slides: {
              spacing: 16,
            },
          },
        },
      },
      [(slider) => initializetionSlide(slider)]
    );

    function initializetionSlide(slider) {
      let arrows__prev = document.querySelector("#section-recipe .arrow__prev");
      let arrows__next = document.querySelector("#section-recipe .arrow__next");

      arrows__next.addEventListener("click", () => {
        slider.next();
      });

      arrows__prev.addEventListener("click", () => {
        slider.prev();
      });

      function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0
          ? arrows__prev.classList.add("arrow--disabled")
          : arrows__prev.classList.remove("arrow--disabled");

        slide === slider.track.details.slides.length - 1
          ? arrows__next.classList.add("arrow--disabled")
          : arrows__next.classList.remove("arrow--disabled");
      }

      // Adiciona eventos no slider para atualizar os botões
      slider.on("created", updateClasses);
      slider.on("slideChanged", updateClasses);
    }
  },
  recipesBossCarrossel: function () {
    new KeenSlider(
      "#receipe--slider",
      {
        loop: false,
        mode: "snap",
        rtl: false,
        slides: {
          perView: "auto",
          spacing: 16,
        },
        breakpoints: {
          "(max-width: 767px)": {
            slides: {
              spacing: 10,
            },
          },
        },
      },
      [(slider) => initializetionSlide(slider)]
    );

    function initializetionSlide(slider) {
      let arrows__prev = document.querySelector("#boss-recipe .arrow__prev");
      let arrows__next = document.querySelector("#boss-recipe .arrow__next");

      arrows__next.addEventListener("click", () => {
        slider.next();
      });

      arrows__prev.addEventListener("click", () => {
        slider.prev();
      });

      function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0
          ? arrows__prev.classList.add("arrow--disabled")
          : arrows__prev.classList.remove("arrow--disabled");

        slide === slider.track.details.slides.length - 1
          ? arrows__next.classList.add("arrow--disabled")
          : arrows__next.classList.remove("arrow--disabled");
      }

      // Adiciona eventos no slider para atualizar os botões
      slider.on("created", updateClasses);
      slider.on("slideChanged", updateClasses);
    }
  },
  productsCarrossel: function () {
    new KeenSlider("#carrossel-mobile_products", {
      loop: false,
      mode: "snap",
      rtl: false,
      slides: {
        perView: "auto",
        spacing: 12,
      },
    });
  },
  productsInternal: function () {
    new KeenSlider("#slide-camponesa .keen-slider", {
      loop: false,
      mode: "snap",
      rtl: false,
      slides: {
        perView: "auto",
        spacing: 16,
      },
      breakpoints: {
        "(max-width: 767px)": {
          slides: {
              perView: "auto",
            spacing: 10,
          },
        }
      },
    }, [
      (slider) => initializetionSlide(slider)
    ]);

    function initializetionSlide(slider) {
      let arrows__prev = document.querySelector("#slide-camponesa .arrow__prev");
      let arrows__next = document.querySelector("#slide-camponesa .arrow__next");

      arrows__next.addEventListener('click', () => {
        slider.next();
      })

      arrows__prev.addEventListener('click', () => {
        slider.prev();
      })

      function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0 ?
          arrows__prev.classList.add("arrow--disabled") :
          arrows__prev.classList.remove("arrow--disabled");

        slide === slider.track.details.slides.length - 1 ?
          arrows__next.classList.add("arrow--disabled") :
          arrows__next.classList.remove("arrow--disabled");
      }

      // Adiciona eventos no slider para atualizar os botões
      slider.on("created", updateClasses);
      slider.on("slideChanged", updateClasses);
    }
  },
  preparetionInternal: function () {
    const mainSlider = document.querySelector("#slider-prepation");
    const sliders = mainSlider.querySelectorAll(".keen-slider__slide");

    function updateHeight() {
      const widthScreen = window.innerWidth;
      if (widthScreen > 992) {
        
        const contentBoxes = document.querySelectorAll("#slider-prepation .keen-slider__slide .box .information");

        // Encontra a altura máxima entre os conteúdos
        let maxHeight = 0;
        contentBoxes.forEach(box => {
          maxHeight = Math.max(maxHeight, box.offsetHeight);
        });

        sliders.forEach(el => {
          el.style.height = `${maxHeight}px`;
        });

        return maxHeight;
      }

    }

    new KeenSlider("#slider-prepation", {
      loop: false,
      mode: "free-snap",
      disabled: true,
      renderMode: "precision",
      slides: {
        perView: "1",
        spacing: 16,
      },
      breakpoints: {

        "(max-width: 992px)": {
          perView: "1",
          vertical: false,
          disabled: false,
        },
      },
      vertical: true,
    }, [
      (slider) => {
        addNavigation(slider); // Configura os botões de navegação
        const height = updateHeight(); // Ajusta a altura no início

        if (window.innerWidth > 992) {
          mainSlider.style.height = `${height}px`;
        }
      }
    ]);

    // Função para adicionar a navegação
    function addNavigation(slider) {
      const arrowsPrev = document.querySelector("#preparation-method .arrow__prev");
      const arrowsNext = document.querySelector("#preparation-method .arrow__next");

      var indexSlide = 0;

      // Eventos para os botões de navegação
      arrowsNext.addEventListener("click", () => slider.next());
      arrowsPrev.addEventListener("click", () => slider.prev());

      // Atualiza o estado dos botões
      function updateClasses() {
        const currentSlide = slider.track.details.rel;
        const maxIndexSlide = slider.track.details.slides.length - 1;
        const slideHeight = updateHeight() + 40;

        sliders.forEach((item, index) => {
          if(index == currentSlide){
            item.querySelector(".box").classList.remove("zoom");
            item.querySelector(".box").classList.remove("opacity");
          }else{
            item.querySelector(".box").classList.add("zoom");
            item.querySelector(".box").classList.add("opacity");
          }
        })

        if(currentSlide > indexSlide){
          let indexInit = 0;
          for( indexInit; indexInit <= maxIndexSlide; indexInit++){
            let calc = currentSlide * Number(slideHeight);
            sliders[indexInit].style.transform = `translate(0, -${calc}px)`;
          }
        }

        if(currentSlide < indexSlide){
          let indexInit = maxIndexSlide;
          for(indexInit; indexInit >= 0; indexInit--){
            let calc = currentSlide * Number(slideHeight);
            sliders[indexInit].style.transform = `translate(0, -${calc}px)`;
          } 
        }

        indexSlide = currentSlide;
        arrowsPrev.classList.toggle("arrow--disabled", currentSlide === 0);
        arrowsNext.classList.toggle("arrow--disabled", currentSlide === maxIndexSlide);
      }

      slider.on("updated", updateHeight);
      slider.on("created", updateClasses);
      slider.on("slideChanged", updateClasses);

      window.addEventListener("resize", updateHeight);
    }
  }
};

// Inicializa o controlador de tamanhos de fonte
document.addEventListener('DOMContentLoaded', () => {
  GlobalCarrosseis.init();
});
